import { h, clear } from './dom.js'

// Minimal modal. openDialog renders `body` (an element) with a title and
// action buttons; resolves with the clicked action's value (null on dismiss).

let overlay = null

export function openDialog({ title, body, actions }) {
  closeDialog()
  return new Promise((resolve) => {
    const finish = (value) => {
      closeDialog()
      resolve(value)
    }
    const box = h(
      'div.dialog',
      { role: 'dialog', 'aria-modal': 'true', 'aria-label': title },
      h('header.dialog-title', {}, title),
      h('div.dialog-body', {}, body),
      h(
        'footer.dialog-actions',
        {},
        actions.map(({ label, value, primary, danger }) =>
          h(
            `button.btn${primary ? '.primary' : ''}${danger ? '.danger' : ''}`,
            { type: 'button', onClick: () => finish(value) },
            label,
          ),
        ),
      ),
    )
    overlay = h('div.dialog-overlay', {
      onClick: (e) => {
        if (e.target === overlay) finish(null)
      },
      onKeydown: (e) => {
        if (e.key === 'Escape') finish(null)
      },
    })
    overlay.appendChild(box)
    document.body.appendChild(overlay)
    const firstButton = box.querySelector('.dialog-actions .btn.primary') ?? box.querySelector('button')
    firstButton?.focus()
  })
}

export function closeDialog() {
  overlay?.remove()
  overlay = null
}

export async function confirmDialog({ title, message, confirmLabel = 'Continue', danger = false }) {
  const result = await openDialog({
    title,
    body: h('p.dialog-message', {}, message),
    actions: [
      { label: 'Cancel', value: false },
      { label: confirmLabel, value: true, primary: !danger, danger },
    ],
  })
  return result === true
}
